import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../services';

export const authenticationGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userService: UserService = inject(UserService);

  const isAuthenticated = userService.isAuthenticated();

  if (!isAuthenticated) {
    router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url } });
  }

  return isAuthenticated;
};
